import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#2B2B2B",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 2H0v11.399L.615 14h14.77l.615-.568V2zm-1 1V13H1V3h14z",
			fillRule: "nonzero"
		}), /* @__PURE__ */ _jsx("path", { d: "M14 5 8 7.857V9l6-2.857zM2 5l6 2.857V9L2 6.143z" })]
	})
});
export default SvgMessage;
